import { Injectable } from '@angular/core';
import { rejects } from 'assert';
import { resolve } from 'dns';
import { promise } from 'selenium-webdriver';
import { KDTreeService } from './kdtree.service';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { MapService } from 'src/app/Services/map.service';
import { split } from 'ts-node';
import { SharedService } from './shared.service';
declare const turf;

@Injectable()

export class RouteService {
  // osrmUrl = 'http://localmap.g10.pw:5000/route/v1/driving/';    // find distance
  // osrmUrlloc = 'http://localmap.g10.pw:5000/nearest/v1/driving/';   //find nearest location
  // osrmUrl = 'https://router.project-osrm.org/route/v1/driving/';    // find distance - Global
  // osrmUrlloc = 'https://router.project-osrm.org/nearest/v1/driving/';   //find nearest location -Global
  // osrmUrl = 'http://172.16.0.77:5000/route/v1/driving/';    // find distance
  // osrmUrlloc = 'http://172.16.0.77:5000/nearest/v1/driving/';   //find nearest location
  // osrmUrl = 'https://demo-map.g10.pw/route/v1/driving/';    // find distance
  // osrmUrlloc = 'https://demo-map.g10.pw/nearest/v1/driving/';   //find nearest location
  distForclust = 500; // dist 500 in meters
  routeType: string;    // 1-pickup, 0-drop
  route_opt = 1;       // 1-management fav , 0-driver fav(zigzag)
  officeLoc = {};
  final_route: any = {};
  count_r: number = 0;
  mapData = [];
  EtaTime = 0;
  EtaDist = 0;
  orgveh: any;
  unAssignedEmp = [];
  // routeObj: any = [
  //   // {
  //   //   cabInfo: [
  //   //     {
  //   //       Cab_Id: 0,
  //   //       cabRegNo: 'TN00AB0000',
  //   //       CarName: 'indica',
  //   //       SeatCap: 6,
  //   //       Req_Seat: 3,
  //   //       shift: 'First',
  //   //       model: 'Hatchback',
  //   //       Class: 'Normal',
  //   //       location: {
  //   //         lat: 12.949412,
  //   //         lng: 80.239491
  //   //       }
  //   //     }, {
  //   //       Cab_Id: 0,
  //   //       cabRegNo: 'TN11AB1111',
  //   //       CarName: 'indica',
  //   //       SeatCap: 6,
  //   //       Req_Seat: 1,
  //   //       shift: 'First',
  //   //       model: 'Hatchback',
  //   //       Class: 'Normal',
  //   //       location: {
  //   //         lat: 12.973122,
  //   //         lng: 80.245637
  //   //       }
  //   //     }
  //   //   ],
  //   //   employeeInfo: [
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'Test2',
  //   //       name: 'Test2',
  //   //       dob: 1622764800000,
  //   //       gender: 'Female',
  //   //       mobile: '9876543210',
  //   //       email: 'test2@gmail.com',
  //   //       emergencyContact: '9876542234',
  //   //       bloodGroup: 'A',
  //   //       address: 'Guindy',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'India',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 13.081479,
  //   //         lng: 80.217527,
  //   //         name: 'Sanabel Biriyani Point, Chennai, Tamil Nadu, India'
  //   //       },
  //   //       workLocation: 'chennai',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       profile: '/home/devuser/EMPS/API/emps-images/emp_Test2.png',
  //   //       employeeID: '60dd81e709e02e1315c9389d',
  //   //       locationName: 'Sanabel Biriyani Point, Chennai, Tamil Nadu, India'
  //   //     },
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'test123',
  //   //       name: 'test',
  //   //       dob: 1623110400000,
  //   //       gender: 'Male',
  //   //       mobile: '9123451234',
  //   //       email: 'test123@gmail.com',
  //   //       emergencyContact: '9123412342',
  //   //       bloodGroup: 'o',
  //   //       address: 'velachery',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'India',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 13.053499,
  //   //         lng: 80.273431,
  //   //         name: 'Al-Elaf Arabian Restaurant, Chennai, Tamil Nadu, India'
  //   //       },
  //   //       workLocation: 'chennai',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       profile: '/home/devuser/EMPS/API/emps-images/emp_test123.png',
  //   //       employeeID: '60d0639b1837c71372dd5fe7',
  //   //       locationName: 'Al-Elaf Arabian Restaurant, Chennai, Tamil Nadu, India'
  //   //     },
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'asdf123',
  //   //       name: 'asdf',
  //   //       dob: 1622764800000,
  //   //       gender: 'Male',
  //   //       mobile: '1234123412',
  //   //       email: 'asdf@g10.com',
  //   //       emergencyContact: '1234145121',
  //   //       bloodGroup: 'o',
  //   //       address: 'velachery',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'india',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 14.373596,
  //   //         lng: 80.022866,
  //   //         name: 'Kakupalle -Ii, Nellore, Sri Potti Sriramulu Nellore, Andhra Pradesh, India'
  //   //       },
  //   //       workLocation: 'chennai',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       profile: '/home/devuser/EMPS/API/emps-images/emp_asdf123.png',
  //   //       employeeID: '60d041e61837c71372dd5fe6',
  //   //       locationName: 'Kakupalle -Ii, Nellore, Sri Potti Sriramulu Nellore, Andhra Pradesh, India'
  //   //     },
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'asd123',
  //   //       name: 'asd',
  //   //       dob: 1622678400000,
  //   //       gender: 'Male',
  //   //       mobile: '9123412341',
  //   //       email: 'asdr@g10.com',
  //   //       emergencyContact: '9123412323',
  //   //       bloodGroup: 'o-',
  //   //       address: 'vcy',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'india',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 13.056107,
  //   //         lng: 80.231961,
  //   //         name: 'Ayappan Temple, Mahalingapuram, Chennai, Tamil Nadu, India'
  //   //       },
  //   //       workLocation: 'CHENNAI',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       employeeID: '60d03866df9a28d99bd59a3c',
  //   //       locationName: 'Ayappan Temple, Mahalingapuram, Chennai, Tamil Nadu, India'
  //   //     }, {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'Test2',
  //   //       name: 'Test2',
  //   //       dob: 1622764800000,
  //   //       gender: 'Female',
  //   //       mobile: '9876543210',
  //   //       email: 'test2@gmail.com',
  //   //       emergencyContact: '9876542234',
  //   //       bloodGroup: 'A',
  //   //       address: 'Guindy',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'India',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 13.081479,
  //   //         lng: 80.217527,
  //   //         name: 'Sanabel Biriyani Point, Chennai, Tamil Nadu, India'
  //   //       },
  //   //       workLocation: 'chennai',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       profile: '/home/devuser/EMPS/API/emps-images/emp_Test2.png',
  //   //       employeeID: '60dd81e709e02e1315c9389d',
  //   //       locationName: 'Sanabel Biriyani Point, Chennai, Tamil Nadu, India'
  //   //     },
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'test123',
  //   //       name: 'test',
  //   //       dob: 1623110400000,
  //   //       gender: 'Male',
  //   //       mobile: '9123451234',
  //   //       email: 'test123@gmail.com',
  //   //       emergencyContact: '9123412342',
  //   //       bloodGroup: 'o',
  //   //       address: 'velachery',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'India',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 13.053499,
  //   //         lng: 80.273431,
  //   //         name: 'Al-Elaf Arabian Restaurant, Chennai, Tamil Nadu, India'
  //   //       },
  //   //       workLocation: 'chennai',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       profile: '/home/devuser/EMPS/API/emps-images/emp_test123.png',
  //   //       employeeID: '60d0639b1837c71372dd5fe7',
  //   //       locationName: 'Al-Elaf Arabian Restaurant, Chennai, Tamil Nadu, India'
  //   //     },
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'asdf123',
  //   //       name: 'asdf',
  //   //       dob: 1622764800000,
  //   //       gender: 'Male',
  //   //       mobile: '1234123412',
  //   //       email: 'asdf@g10.com',
  //   //       emergencyContact: '1234145121',
  //   //       bloodGroup: 'o',
  //   //       address: 'velachery',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'india',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 14.373596,
  //   //         lng: 80.022866,
  //   //         name: 'Kakupalle -Ii, Nellore, Sri Potti Sriramulu Nellore, Andhra Pradesh, India'
  //   //       },
  //   //       workLocation: 'chennai',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       profile: '/home/devuser/EMPS/API/emps-images/emp_asdf123.png',
  //   //       employeeID: '60d041e61837c71372dd5fe6',
  //   //       locationName: 'Kakupalle -Ii, Nellore, Sri Potti Sriramulu Nellore, Andhra Pradesh, India'
  //   //     },
  //   //     {
  //   //       orgID: '60866279d774d4408635033b',
  //   //       empRefID: 'asd123',
  //   //       name: 'asd',
  //   //       dob: 1622678400000,
  //   //       gender: 'Male',
  //   //       mobile: '9123412341',
  //   //       email: 'asdr@g10.com',
  //   //       emergencyContact: '9123412323',
  //   //       bloodGroup: 'o-',
  //   //       address: 'vcy',
  //   //       city: 'chennai',
  //   //       state: 'Tamil Nadu',
  //   //       country: 'india',
  //   //       pincode: '600042',
  //   //       location: {
  //   //         lat: 13.056107,
  //   //         lng: 80.231961,
  //   //         name: 'Ayappan Temple, Mahalingapuram, Chennai, Tamil Nadu, India'
  //   //       },
  //   //       workLocation: 'CHENNAI',
  //   //       shift: 'secondshift',
  //   //       transportType: 'company',
  //   //       employeeID: '60d03866df9a28d99bd59a3c',
  //   //       locationName: 'Ayappan Temple, Mahalingapuram, Chennai, Tamil Nadu, India'
  //   //     }
  //   //   ]
  //   // },
  // ];
  employee: any;
  cab: any;
  // startLoc: any;
  // endLoc: any;
  osrmUrl: any;
  osrmUrlloc: any;
  public set setOsrmMapUrl(val: any) {
    this.osrmUrl = val.osrmUrl;
    this.osrmUrlloc = val.osrmUrlloc;
  }


  constructor(
    public kdtree: KDTreeService,
    public api: ApiService,
    public storage: StorageService,
    public map: MapService,
    private share: SharedService,
  ) {

    this.share._subject.subscribe((data: any) => {       // getting data from top-header-menu  
      if (data.type == 'osrm_url') {
        this.setOsrmMapUrl = data.data;
      }
    });
  }
  shortPickuppoints(cab: any, pickpts: any) {
    return new Promise(async (resolve, reject) => {
      const obj = { startLatLng: cab, pickupPoints: pickpts };
      this.api.GetNearestLocation(obj).then((res: any) => {
        resolve(res);
      }).catch((resCatch: any) => {
        reject(resCatch)
      });
    });
  }

  RouteCreateNextmv(data:any){
    return new Promise(async (resolve,reject)=>{
      let obj = { data : data}
      this.api.RouteGenerate(obj).then((res:any)=>{
        console.log("res",res);
        resolve(res)
        }).catch((e)=>{
        reject(e)
      });
    });
  }

  routeCreate(routeGenInputObj) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("routeGenInputObj", routeGenInputObj);
        this.routeType = routeGenInputObj[0].transitMode;
        const employee = routeGenInputObj[0].employeeInfo;
        const safeDrop = routeGenInputObj[0].safeDrop;
        this.cab = routeGenInputObj[0].cabInfo;
        console.log(this.routeType, "Route Will be create", employee, this.cab,"safeDrop -",safeDrop);
        let route_obj = await this.makeRoute(employee, this.cab, this.routeType).catch((e)=>{throw e});   // create route for selected emp and cab
        //  console.log("Route - ",route_obj)
        console.log('Stage -1 , Route created');

        const empPickpts = await this.separatePickpts(route_obj).catch((e)=>{throw e});   // separate emp loc details for create cluspts
        // console.log("emppick",empPickpts)
        const routeCluspts = await this.createClusPts(route_obj, empPickpts).catch((e)=>{throw e});  // ->make routes with cluster points
        console.log("Stage -2 , cluster points created - ", routeCluspts)
        let orderedPts: any;
        if (safeDrop) {
          orderedPts = await this.orderByGender(routeCluspts, employee).catch((e)=>{throw e});
          console.log("orderedPts", orderedPts)
        }
        else orderedPts = routeCluspts;
        const shortPts = await this.makeshortRoutePts(orderedPts).catch((e)=>{throw e});     // get shortest route for pickup pts
        console.log("Stage -3 , short route created")

        // const routeCabEmp = await this.getCabEmpdetails(shortPts, this.cab, this.employee);    // get all about details of cab and emp
        const routeCabEmp = await this.getCabEmpdetails(shortPts, this.cab, employee).catch((e)=>{throw e});    // get all about details of cab and emp
        console.log("Stage -4 , Almost route created",routeCabEmp);
        // const groupRoute = await this.groupRoute(routeCabEmp);
        // console.log('Group by Vehicle model', groupRoute);
        let result = {};
        result['finalRoute'] = await this.finalRoute(routeCabEmp).catch((e)=>{throw e});
        result['unAssignedEmp'] = this.unAssignedEmp;
        // console.log("Final Route created",finalRoute)
        // return
        resolve(result);
      }
      catch (error) {
        reject(error)
      }
    })
  }


  makeRoute(employee: any, cab: any, routeType) {

    return new Promise(async (resolve, reject) => {
      try {
        var emp_latlng = employee.map(value => value.location); // Separate emp location in array for find the shortest route
        let temp_obj = {}, temp_arr2: any[] = [], i = 0, cab_len = 0, seat_cnt = 0; this.unAssignedEmp = [];
        cab_len = cab.length;
        for (i = 0; i < cab.length; i++) seat_cnt += Number(cab[i].SeatCapacity);
        while (seat_cnt && emp_latlng.length) {
          for (let j = 0; j < cab_len && emp_latlng.length != 0; j++) {
            const temp_arr = await this.kdtree.findNearestLocation(emp_latlng, cab[j].startLoc, emp_latlng.length);
            if (routeType == "Pickup") {
              for (let count = 0; count < cab[j].SeatCapacity && emp_latlng.length; count++) {
                temp_arr2.push(temp_arr[count][0]);
                seat_cnt -= 1;
                this.delete_arr(emp_latlng, temp_arr[count][0]);
              }
            } else if (routeType == "Drop") {
              for (let count = 0; count < cab[j].SeatCapacity && emp_latlng.length; count++) {
                temp_arr2.unshift(temp_arr[count][0]);
                seat_cnt -= 1;
                this.delete_arr(emp_latlng, temp_arr[count][0]);
              }
            }
            temp_obj[cab[j].vehRegNo] = temp_arr2;
            temp_obj[cab[j].vehRegNo].cab_d = cab[j];
            temp_arr2 = [];
          }
          // console.log("Loop", emp_latlng,emp_latlng.length,seat_cnt)
        }
        if (emp_latlng.length) {
          for (let i = 0; emp_latlng.length > i; i++) {
            for (let j = 0; employee.length > j; j++) {
              if (employee[j].location.lat == emp_latlng[i].lat && employee[j].location.lng == emp_latlng[i].lng) {
                this.unAssignedEmp.push(employee[j]);
                break;
              }
            }
          }
        }
        // console.log("unAssignedEmp", this.unAssignedEmp);
        // }
        resolve(temp_obj);
      }
      catch (error) {
        reject(error)
      }
    });

  }

  separatePickpts(tobj) {
    return new Promise(async (resolve, reject) => {
      try {
        let temp = [], temp_arr = [], tempkeys1 = Object.keys(tobj);
        for (let i = 0; i < tempkeys1.length; i++) {
          let count = 0;
          const tempkeys = Object.keys(tobj[tempkeys1[i]]).filter(item => {
            if (Number(item) == 0 || Number(item)) { return item; }
          });
          for (let j = 0; j < tobj[tempkeys1[i]].length; j++) {
            temp[count++] = tobj[tempkeys1[i]][tempkeys[j]];
          }
          temp_arr[tempkeys1[i]] = temp;
          temp = [];
        }
        // console.log("separatepickpts",temp_arr)
        resolve(temp_arr);      // returning only emp location(lat: and lng:) details
      }
      catch (error) {
        reject(error)
      }
    });

  }

  createClusPts(routes, temp_arr) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("temp_arr",temp_arr);
        const tempkeys: string[] = Object.keys(temp_arr);
        let count: any, j: any, k: any, res: any, res1: any, url: any, clust: boolean = false, temp_arr1: any[] = [], temp_arr2: any[] = [], local_obj: any = {}, value: any;
        for (let i = 0; i < tempkeys.length; i++) {
          j = 0, k = 1, count = 0;
          const element: string = tempkeys[i];
          // console.log("element",[tempkeys[i]])
          if (temp_arr[element].length == 1) { temp_arr2[count++] = (temp_arr[element][j]); } else {
            while (1) {
              value = 0;
              url = this.osrmUrl + temp_arr[element][j].lng + ',' + temp_arr[element][j].lat + ';' + temp_arr[element][k].lng + ',' + temp_arr[element][k].lat + '?steps=true';
              // console.log(url);
              res = await this.fetchUrl(url);
              url = this.osrmUrl + temp_arr[element][k].lng + ',' + temp_arr[element][k].lat + ';' + temp_arr[element][j].lng + ',' + temp_arr[element][j].lat + '?steps=true';
              res1 = await this.fetchUrl(url);
              value = Math.min(res.routes[0].distance, res1.routes[0].distance);

              if (value < this.distForclust) {
                if (!temp_arr1.some(ele => ele.lat === temp_arr[element][j].lat && ele.lng === temp_arr[element][j].lng)) {
                  temp_arr1.push(temp_arr[element][j]);
                  temp_arr1.push(temp_arr[element][k]);
                } else {
                  temp_arr1.push(temp_arr[element][k]);
                }
                clust = true;
                k++;
                if (temp_arr[element][k] == undefined) {
                  const midPt = await this.findMidpt(temp_arr1).catch((e)=>{throw e});
                  temp_arr2[count] = midPt;
                  if (temp_arr2[count] == undefined) { temp_arr2[count] = {}; }
                  temp_arr2[count++].clusPts = temp_arr1;
                  clust = false;
                  temp_arr1 = [];
                }

              } else {
                if (clust) {
                  const midPt = await this.findMidpt(temp_arr1).catch((e)=>{throw e});
                  temp_arr2[count] = midPt;
                  if (temp_arr2[count] == undefined) { temp_arr2[count] = {}; }
                  temp_arr2[count++].clusPts = temp_arr1;
                  clust = false;
                  temp_arr1 = [];
                } else {
                  // console.log("arrr",temp_arr[element][j],count)
                  temp_arr2[count++] = (temp_arr[element][j]);
                }
                j = k;
                k++;
                if (temp_arr[element][k] == undefined) {
                  // console.log("arrr-end",temp_arr[element][j])
                  temp_arr2[count++] = (temp_arr[element][j]);
                }
              }
              if (temp_arr[element].length == k) { break; }
              // console.log("before final",temp_arr2)
            }
          }
          temp_arr2['cabInfo'] = routes[tempkeys[i]].cab_d;
          // console.log("Final == ", routes[tempkeys[i]],temp_arr2)
          local_obj[tempkeys[i]] = temp_arr2;
          // console.log("localobj",local_obj)
          // local_obj["route" + (i + 1)] = temp_arr2
          temp_arr1 = [], temp_arr2 = [];
        }
        resolve(local_obj);  // returning modified group route(cluster pickuppoints)
      }
      catch (error) {
        reject(error)
      }
    });

  }

  orderByGender(temp_obj, employee) {
    return new Promise(async (resolve, reject) => {
      try {
        let tempkeys, tempkeys1, genDer;
        tempkeys = Object.keys(temp_obj);
        for (let i = 0; i < tempkeys.length; i++) {
          const element = tempkeys[i];
          tempkeys1 = Object.keys(temp_obj[tempkeys[i]]);
          // console.log("temp1", tempkeys1,tempkeys[i].length)
          for (let j = 0; j < temp_obj[element].length; j++) {
            const element1 = tempkeys1[j];
            // console.log("sec")
            for (const key in employee) {
              if (employee[key].location == temp_obj[tempkeys[i]][element1]) {
                genDer = employee[key].gender;
                break;
              }
            }
            // console.log("genDer",genDer,j,tempkeys1,tempkeys1[j],temp_obj[element][element1],tempkeys1.length)
            if (!temp_obj[element][tempkeys1[j]].clusPts && genDer == 'Male' && j == 0) {
              // console.log("inside if")
              break;
            } else if (!temp_obj[element][element1].clusPts && genDer == 'Male') {
              // console.log("remove ",j)
              temp_obj[element].unshift(temp_obj[element][element1]);
              temp_obj[element].splice(j + 1, 1);
              break;
            }
            genDer = null;
          }
        }
        // console.log("reordered ", temp_obj)
        resolve(temp_obj);
      }
      catch (error) {
        reject(error)
      }
    });

  }

  makeshortRoutePts(tobj) {
    return new Promise(async (resolve, reject) => {
      try{
      let j: any, tempkeys: any[] = [], tempkeys1: any[] = [], temp_obj1: any = {}, temp_obj: any = {}, local_obj1: any = {}, k: number = 0, res: any, Etadist = 0, Etatime = 0;
      tempkeys = Object.keys(tobj);
      for (let i = 0; i < tempkeys.length; i++) {
        k = 0;
        tempkeys1 = Object.keys(tobj[tempkeys[i]]);
        temp_obj[k++] = tobj[tempkeys[i]].cabInfo.startLoc;
        for (j = 0; j < (tobj[tempkeys[i]].length); j++) {
          temp_obj[k++] = tobj[tempkeys[i]][tempkeys1[j]];
        }
        if (this.routeType == "Pickup") { res = await this.shortPickuppoints(tobj[tempkeys[i]].cabInfo.startLoc, temp_obj).catch((e)=>{throw e}); }
        else { res = await this.shortPickuppoints(tobj[tempkeys[i]].cabInfo.startLoc, temp_obj).catch((e)=>{throw e}); }  // get shortest route for drop pts
        // else { res = await this.shortPickuppoints(this.officeLoc['location'], temp_obj); }  // get shortest route for drop pts
        j = 1;

        temp_obj1.cabInfo = tobj[tempkeys[i]].cabInfo;
        for (let m = 1; m < (res.data.path.length - 1); m++) {
          temp_obj1[j++] = temp_obj[res.data.path[m]];
        }
        if (this.routeType == "Pickup") {
          temp_obj1[0] = tobj[tempkeys[i]].cabInfo.startLoc;
          temp_obj1[j] = tobj[tempkeys[i]].cabInfo.endLoc;
        }
        else if (this.routeType == "Drop") {
          temp_obj1[0] = tobj[tempkeys[i]].cabInfo.endLoc;
        }
        var temp_keys = Object.keys(temp_obj1).filter(item => {
          if (Number(item) == 0 || Number(item)) { return item; }
        });
        console.log("make routea",temp_obj1)
        for (let l = 0; l < temp_keys.length - 1; l++) {
          let count = l + 1;
          let url = this.osrmUrl + temp_obj1[l].lng + ',' + temp_obj1[l].lat + ';' + temp_obj1[count].lng + ',' + temp_obj1[count].lat + '?steps=true';
          res = await this.fetchUrl(url).catch((e)=>{throw e});
          temp_obj1[count]["eta"] = await this.convertMinsToHrsMins(Math.round(res.routes[0].duration / 60)).catch((e)=>{throw e});
          temp_obj1[count]["distance"] = (res.routes[0].distance / 1000).toFixed(3);
          Etatime += res.routes[0].duration / 60;
          Etadist += Number(res.routes[0].distance / 1000);
        }
        temp_obj1.TotalDuration = Math.round(Etatime);
        temp_obj1.distance = (Etadist.toFixed(1));
        this.EtaTime = 0;
        this.EtaDist = 0;
        Etatime = 0;
        Etadist = 0;
        // console.log(temp_obj1);
        local_obj1[tempkeys[i]] = temp_obj1;
        temp_obj = {};
        temp_obj1 = {};

      }
      //  console.log("madeshortRoutePts-comp",local_obj1);
      resolve(local_obj1);      // returning only emp location(lat: and lng:) details
    }
    catch(error) {
      reject(error)
    }
  });


  }

  getCabEmpdetails(tobj: unknown, cabInfo: string | any[], employeeInfo: string | any[]) {
    return new Promise(async (resolve, reject) => {
      try{
      const tempkeys = Object.keys(tobj);
      for (let i = 0; i < tempkeys.length; i++) {
        // console.log("cab", cabInfo , cabInfo.length);
        for (let j = 0; j < cabInfo.length; j++) {
          if (tobj[tempkeys[i]].cabInfo.location == cabInfo[j].location) {
            if (this.routeType == 'Pickup')
              tobj[tempkeys[i]][0] = cabInfo[j];
            tobj[tempkeys[i]].cabInfo = cabInfo[j];
            break;
          }
        }
      }
      // console.log("keys sec", tempkeys)
      for (let i = 0; i < tempkeys.length; i++) {
        const tempkeys1 = Object.keys(tobj[tempkeys[i]]).filter(item => {
          if (Number(item) == 0 || Number(item)) { return item; }
        });
        let clusPtsflag = 0, clusMale = 0, clusFemale = 0, genMale = 0, genFemale = 0, pickupPoint = 0;
        for (let j = 0; j < tempkeys1.length; j++) {
          if (tobj[tempkeys[i]][tempkeys1[j]].clusPts) {
            pickupPoint += 1;
            for (let k = 0; k < tobj[tempkeys[i]][tempkeys1[j]].clusPts.length; k++) {
              for (let m = 0; m < employeeInfo.length; m++) {
                if (tobj[tempkeys[i]][tempkeys1[j]].clusPts[k] == employeeInfo[m].location) {
                  tobj[tempkeys[i]][tempkeys1[j]].clusPts[k] = employeeInfo[m];
                  if (employeeInfo[m].gender == 'Male') { clusMale += 1; }
                  if (employeeInfo[m].gender == 'Female') { clusFemale += 1; }
                  break;
                }
              }
            }
            clusPtsflag += 1;
          } else {
            for (let k = 0; k < employeeInfo.length; k++) {
              if (tobj[tempkeys[i]][tempkeys1[j]].lat == employeeInfo[k].location.lat && tobj[tempkeys[i]][tempkeys1[j]].lng == employeeInfo[k].location.lng) {
                tobj[tempkeys[i]][tempkeys1[j]] = employeeInfo[k];
                if (employeeInfo[k].gender == 'Male') { genMale += 1; }
                if (employeeInfo[k].gender == 'Female') { genFemale += 1; }
                pickupPoint += 1;
                break;
              }
            }
          }
          // console.log("this.routeType" ,this.routeType,tempkeys1.length,j)
                        // if (this.routeType == 'Pickup' && j + 1 == tempkeys1.length) {
                        //   // console.log("pickup---",this.routeType)
                        //   this.endLoc['location'] = tobj[tempkeys[i]][tempkeys1[j]];
                        //   tobj[tempkeys[i]][tempkeys1[j]] = this.endLoc;
                        // }
                        // else if (this.routeType == 'Drop' && j == 0) {
                        //   tobj[tempkeys[i]][tempkeys1[j]] = this.startLoc;
                        // }
        }
        if (!genMale) { tobj[tempkeys[i]].participants = 'Female'; } else if (!genFemale) { tobj[tempkeys[i]].participants = 'Male'; } else { tobj[tempkeys[i]].participants = 'MaleAndFemale'; }
        // console.log("count",genMale , genFemale , clusMale , clusFemale);
        tobj[tempkeys[i]].totalemp = genMale + genFemale + clusMale + clusFemale;
        tobj[tempkeys[i]].totalclus = clusPtsflag;
        tobj[tempkeys[i]].pickuppoints = pickupPoint;
        tobj[tempkeys[i]].totalmale = genMale + clusMale;
        tobj[tempkeys[i]].totalfemale = genFemale + clusFemale;
      }
      // console.log("final_route_details",tobj)
      resolve(tobj);
    }
    catch(error) {
      reject(error)
    }
  });

  }

  groupRoute(tobj) {
    return new Promise(async (resolve, reject) => {
      try{
      let tempkeys = Object.keys(tobj), tempobj_arr = [];
      // for (let i = 0; i < tempkeys.length; i++) {
      //   if (tobj[tempkeys[i]].cabInfo.model == 'Hatchback') {
      //     if (temp_obj.Hatchback == undefined) { 
      //       temp_obj.Hatchback = {}; 
      //       temp_obj.Hatchback.routeInfo={}; }
      //     temp_obj.Hatchback.routeInfo[tempkeys[i]] = (tobj[tempkeys[i]]);
      //   } else if (tobj[tempkeys[i]].cabInfo.model == 'Sedan') {
      //     if (temp_obj.Sedan == undefined) { temp_obj.Sedan = {}; 
      //     temp_obj.Sedan.routeInfo={}; }
      //     temp_obj.Sedan.routeInfo[tempkeys[i]] = (tobj[tempkeys[i]]);
      //   } else if (tobj[tempkeys[i]].cabInfo.model == 'SUV') {
      //     if (temp_obj.SUV == undefined) { temp_obj.SUV = {}; 
      //     temp_obj.SUV.routeInfo={}; }
      //     temp_obj.SUV.routeInfo[tempkeys[i]] = (tobj[tempkeys[i]]);
      //   } else if (tobj[tempkeys[i]].cabInfo.model == 'Van') {
      //     if (temp_obj.Van == undefined) { temp_obj.Van = {};
      //     temp_obj.Van.routeInfo={}; }
      //     temp_obj.Van.routeInfo[tempkeys[i]] = (tobj[tempkeys[i]]);
      //   } else if (tobj[tempkeys[i]].cabInfo.model == 'Bus') {
      //     if (temp_obj.Bus == undefined) { temp_obj.Bus = {};
      //     temp_obj.Bus.routeInfo={}; }
      //     temp_obj.Bus.routeInfo[tempkeys[i]] = (tobj[tempkeys[i]]);
      //   }
      // }
      //-- const temp_obj1: any = temp_obj;
      const temp_obj1: any = tobj;
      //-- tempkeys = Object.keys(temp_obj1);
      // console.log("tempkeys",tempkeys)
      for (let j = 0; j < tempkeys.length; j++) {
        let T_pickupPoint = 0, T_totalclus = 0, T_totalmale = 0, T_totalfemale = 0, T_emp = 0, T_route = 0;
        //-- const tempkeys1 = Object.keys(temp_obj1[tempkeys[j]].routeInfo);
        const tempkeys1 = Object.keys(temp_obj1);
        for (let k = 0; k < tempkeys1.length; k++) {
          // T_emp += temp_obj1[tempkeys[j]].routeInfo[tempkeys1[k]].totalemp;
          // T_pickupPoint += temp_obj1[tempkeys[j]].routeInfo[tempkeys1[k]].pickuppoints;
          // T_totalclus += temp_obj1[tempkeys[j]].routeInfo[tempkeys1[k]].totalclus;
          // T_totalmale += temp_obj1[tempkeys[j]].routeInfo[tempkeys1[k]].totalmale;
          // T_totalfemale += temp_obj1[tempkeys[j]].routeInfo[tempkeys1[k]].totalfemale;
          // T_route += 1;
          T_emp += temp_obj1[tempkeys1[j]].totalemp;
          T_pickupPoint += temp_obj1[tempkeys1[j]].pickuppoints;
          T_totalclus += temp_obj1[tempkeys1[j]].totalclus;
          T_totalmale += temp_obj1[tempkeys1[j]].totalmale;
          T_totalfemale += temp_obj1[tempkeys1[j]].totalfemale;
          T_route += 1;
        }
        temp_obj1[tempkeys1[j]].pickuppoints = T_pickupPoint;
        temp_obj1[tempkeys1[j]].totalmale = T_totalmale;
        temp_obj1[tempkeys1[j]].totalfemale = T_totalfemale;
        temp_obj1[tempkeys1[j]].totalclus = T_totalclus;
        temp_obj1[tempkeys1[j]].totalemp = T_emp;
        temp_obj1[tempkeys1[j]].totalroute = T_route;
      }
      tempobj_arr = temp_obj1
      resolve(tempobj_arr);
    }
    catch(error) {
      reject(error)
    }
  });

  }

  finalRoute(groupRoute) {
    return new Promise(async (resolve, reject) => {
      try{
      let finalObj = [], route;
      if (this.routeType == 'Pickup') route = 'pickupInfo';
      else route = 'dropInfo';
      let tempkeys1 = Object.keys(groupRoute);
      //-- for(let i=0;tempkeys.length > i;i++){
      //-- let tempkeys1 = Object.keys(groupRoute[tempkeys[i]].routeInfo);
      for (let j = 0; tempkeys1.length > j; j++) {
        //-- let tempObj={},tempObj1={}, tempArr=[], routeObj = groupRoute[tempkeys[i]].routeInfo[tempkeys1[j]];
        let tempObj = {}, tempObj1 = {}, tempArr = [], routeObj = groupRoute[tempkeys1[j]], count;
        tempObj['cabInfo'] = routeObj.cabInfo;
        var numerickeys = Object.keys(routeObj).filter(item => {
          if (Number(item) == 0 || Number(item)) { return item; }
        });
        tempObj[route] = [];
        // console.log("route info ",route)
        // tempArr.push(routeObj[0])
        //-- for(let k=1;numerickeys.length-1 > k;k++){
        if (this.routeType == 'Drop') count = numerickeys.length;
        else if (this.routeType == 'Pickup') count = numerickeys.length - 1;
        for (let k = 1; k < count; k++) {
          tempObj1 = {};
          // console.log("inside",routeObj[numerickeys[k]])
          if (routeObj[numerickeys[k]].clusPts) {
            tempObj1["lat"] = routeObj[numerickeys[k]].lat;
            tempObj1["lng"] = routeObj[numerickeys[k]].lng;
            tempObj1["eta"] = routeObj[numerickeys[k]].eta;
            tempObj1["distance"] = routeObj[numerickeys[k]].distance;
            tempObj1["locationName"] = routeObj[numerickeys[k]].locationName;
            tempObj1["title"] = routeObj[numerickeys[k]].locationName;
            tempObj1["employees"] = routeObj[numerickeys[k]].clusPts;

          }
          else {
            tempObj1["lat"] = routeObj[numerickeys[k]].location.lat;
            tempObj1["lng"] = routeObj[numerickeys[k]].location.lng;
            tempObj1["eta"] = routeObj[numerickeys[k]].location.eta;
            tempObj1["distance"] = routeObj[numerickeys[k]].location.distance;
            tempObj1["locationName"] = routeObj[numerickeys[k]].location.name;
            let title = routeObj[numerickeys[k]].location.name.split(',');
            tempObj1["title"] = title[0];
            tempObj1["employees"] = [];
            tempObj1["employees"].push(routeObj[numerickeys[k]]);
          }
          // console.log(tempObj1)
          tempArr.push(tempObj1);  //Save office location at last postion
          // if (this.routeType == 'Pickup' && k + 1 == count) {
          //   tempArr.push(routeObj[numerickeys[k + 1]])
          // }
        }
                  // if (this.routeType == 'Pickup') {
                  //   tempObj['startLoc'] = routeObj[0].location;
                  //   tempObj['endLoc'] = this.endLoc['location'];
                  // }
                  // else if (this.routeType == 'Drop')
                  //   tempObj['startLoc'] = this.startLoc['location'];
        tempObj[route] = tempArr;
        tempObj['totalDuration'] = await this.convertMinsToHrsMins(routeObj.TotalDuration);
        tempObj['distance'] = routeObj.distance;
        tempObj['totalemp'] = routeObj.totalemp;
        tempObj['totalclus'] = routeObj.totalclus;
        tempObj['totalmale'] = routeObj.totalmale;
        tempObj['totalfemale'] = routeObj.totalfemale;
        // console.log("temp" , tempObj);
        finalObj.push(tempObj);
      }
      console.log("final", finalObj)
      // return
      // }
      resolve(finalObj);
    }
    catch(error) {
      reject(error)
    }
  });
}
  plotonMap(tobj) {
    return new Promise(async (resolve, reject) => {

      let local_arr: any[] = [], local_arr1: any, temp_obj1: any = {}, temp_obj: any = {}, temp_arr: any[] = [], count_1: number = 0, count: number = 0, tempkeys: any[] = [], colorArr: any[] = [], routeFinalMapArr: any[] = [];
      tempkeys = Object.keys(tobj);
      colorArr = this.colorGen(Object.keys(tobj).length);
      for (let i = 0; i < tempkeys.length; i++) {
        temp_arr = [], count_1 = 0, count = 0;
        const element = tempkeys[i];
        if (this.routeType == "Pickup") {
          temp_arr[count_1++] = tobj[element].cabInfo.location.lat;
          temp_arr[count_1++] = tobj[element].cabInfo.location.lng;
          local_arr[count++] = temp_arr;
        } else {
          temp_arr[count_1++] = this.officeLoc['location'].lat;
          temp_arr[count_1++] = this.officeLoc['location'].lng;
          local_arr[count++] = temp_arr;
        }
        // console.log("cab location", tobj[element].cabInfo.Location.lat)
        temp_obj.id = tobj[element].cabInfo.cabRegNo;
        // let tempkeys1 = Object.keys(tobj[element])
        const tempkeys1: any = Object.keys(tobj[tempkeys[i]]).filter(item => {
          if (Number(item) == 0 || Number(item)) { return item; }
        });
        // console.log("tempkeys1",tempkeys1)
        for (let j = 0; j < tempkeys1.length; j++) {
          const element1: any = tempkeys1[j];
          temp_arr = [], temp_obj1 = {}, count_1 = 0;
          if (tobj[element][element1].clusPts) {
            temp_arr[count_1++] = tobj[element][element1].lat;
            temp_arr[count_1++] = tobj[element][element1].lng;
            temp_obj1.title = 'cluster';
            temp_obj1.plotMarker = '<img src="assets/images/map/cluster.png" width=30px>';
            // temp_obj1['plotMarker'] = '<div class="mumb_marker_pin" style="background: black; width: 10px;"></div>'
            temp_arr[count_1++] = temp_obj1;
            local_arr[count] = temp_arr;
            if (local_arr[count] == undefined) { local_arr[count] = {}; }
            local_arr[count++].clusPts = tobj[element][element1].clusPts;
          } else {
            temp_arr[count_1++] = tobj[element][element1].location.lat;
            temp_arr[count_1++] = tobj[element][element1].location.lng;
            temp_obj1.title = tobj[element][element1].Empid;
            temp_obj1.plotMarker = '📌';
            if (tobj[element][element1].Gender == 'Male') {
              temp_obj1.plotMarker = '<img src="assets/images/map/male.png" width=30px>';
            } else {
              temp_obj1.plotMarker = '<img src="assets/images/map/female.png" width=30px>';
            }

            // temp_obj1['plotMarker'] = '<div class="mumb_marker_pulse" style="background: black; width: 10px;"></div>'
            temp_arr[count_1++] = temp_obj1;
            local_arr[count++] = temp_arr;
          }

        }
        temp_arr = [], count_1 = 0;
        if (this.routeType == "Drop") {
          temp_arr[count_1++] = tobj[element].cabInfo.location.lat;
          temp_arr[count_1++] = tobj[element].cabInfo.location.lng;
          local_arr[count++] = temp_arr;
        } else {
          temp_arr[count_1++] = this.officeLoc['location'].lat;
          temp_arr[count_1++] = this.officeLoc['location'].lng;
          local_arr[count++] = temp_arr;
        }
        // console.log("localarr",local_arr)
        count = 0;
        local_arr1 = await this.waypoints(local_arr);
        temp_obj.locations = local_arr1;
        temp_obj.color = colorArr[i];
        temp_obj.width = 3;
        temp_obj.lineBearing = 1;
        // temp_obj["dash"] = 2;
        // temp_obj["animation"] = true;
        temp_obj.drawArrow = { colorClass: 'secondary' };
        temp_obj.startMarker = '<img src="assets/images/map/driver.png" width=30px>';
        temp_obj.endMarker = '<img src="assets/images/map/office.png" width=40px>';
        temp_obj.bearingFocus = true;
        routeFinalMapArr.push(temp_obj);
        this.map.flatLine('TestmapRoastering', temp_obj);
        // console.log("map obj",temp_obj)
        // this.mapData.push(temp_obj);
        local_arr = [];
        temp_obj = {};
      }
      // console.log('final result map', routeFinalMapArr);
      resolve(routeFinalMapArr);
    });
  }

  separateNoofRoutes(temp_arr1) {
    return new Promise(async (resolve, reject) => {
      try{
      let route_obj = [], count_r = 1, routes = {}, routes_t = [], count_s;
      route_obj = temp_arr1;
      for (let i = 0; route_obj[i] != null; i++) {   // -> create route separate from route details (cab_d,trip)--//
        // console.log('trip count', route_obj[i].Trip_c);
        for (let j = 0; j < route_obj[i].Trip_c; j++) {
          if (routes[count_r] == undefined) { routes[count_r] = {}; }
          routes[count_r].cab = route_obj[i].cab_d.location;
          for (let k = 0; k < route_obj[i].Trip[j].length; k++) {
            routes_t.push(route_obj[i].Trip[j][k]);
          }
          routes[count_r].emp = routes_t;
          routes_t = [];
          count_r++;
        }
      }
      resolve(routes);
    }
    catch(error) {
      reject(error)
    }
  });

  }

  waypoints(tobj) {
    return new Promise(async (resolve, reject) => {
      try{
      let j, url, res, temp_arr = [], temp_arr1 = [], temp_obj = {};
      // console.log("tobj",tobj)
      for (let i = 0; i < tobj.length; i++) {
        temp_arr1.push(tobj[i]);
        j = i + 1;
        if (tobj[j] == undefined) { break; }
        /// -> we cant compare two times with isterchange latlon results of two lat lng bcoz direction must be start frm first latlng////
        url = this.osrmUrl + tobj[i][1] + ',' + tobj[i][0] + ';' + tobj[j][1] + ',' + tobj[j][0] + '?steps=true&geometries=geojson';
        res = await this.fetchUrl(url);
        const lenCoor = res.routes[0].geometry.coordinates.length;
        for (let j = 0; j < lenCoor; j++) {
          temp_arr[0] = res.routes[0].geometry.coordinates[j][1];
          temp_arr[1] = res.routes[0].geometry.coordinates[j][0];
          temp_arr1.push(temp_arr);
          temp_arr = [];
          temp_obj = {};
        }
      }
      // console.log("res-waypoints",temp_arr1)
      resolve(temp_arr1);
    }
    catch(error) {
      reject(error)
    }
  });

  }

  findMidpt(temp_arr1) {
    return new Promise(async (resolve, reject) => {
      try{
      let features, res, findpt, url, retObj = {
        lat: null,
        lng: null,
        locationName: null
      };
      const temp_arr3 = temp_arr1.map(function (ele) {
        const tarr = [];
        tarr.push(ele.lat);
        tarr.push(ele.lng);
        return tarr;
      });
      features = turf.points(temp_arr3);
      // ([ [13.004125, 80.204540],[13.000182, 80.202950],[12.992344, 80.197290], [12.985139, 80.193051], [12.987933, 80.223452],
      //     [12.986422, 80.22453],[12.995344, 80.21453],[12.989011, 80.21453],[12.976561, 80.226789]]);
      findpt = turf.center(features);
      url = this.osrmUrlloc + findpt.geometry.coordinates[1] + ',' + findpt.geometry.coordinates[0];
      res = await this.fetchUrl(url).catch((e)=>{throw e});
      if (res.code == 'Ok') {
        retObj.lat = res.waypoints[0].location[1];
        retObj.lng = res.waypoints[0].location[0];
        retObj.locationName = res.waypoints[0].name;
        resolve(retObj);
      }
    }
    catch(error) {
      reject(error)
    }
  });

  }

  fetchUrl(url) {
    return new Promise(async (resolve, rejects) => {
      // console.log("in finddist")
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((myJson) => {
          // console.log("hi", myJson);
          resolve(myJson);
        }).catch((e)=>{
          rejects(e)
        });
    });

  }

  colorGen(length) {
    return Array(length).fill(0).map(x => {
      const color = Math.floor(Math.random() * 16777215).toString(16);
      return color.length >= 6 ? '#' + color : '#' + color + '2';
    });
  }

  arr_initial(cab, cab_len) {
    const temp = [];
    for (let i = 0; i < cab_len; i++) {
      const local_arr = {
        cab_d: {},
        Trip_c: 0,
        Trip: [],
      };
      local_arr.cab_d = cab[i].location;
      // local_arr.cab_d.Trip = [];
      temp[i] = local_arr;
    }
    return temp;
  }
  delete_arr(arr, elem) {
    const ind = arr.indexOf(elem);
    arr.splice(ind, 1);
  }

  convertMinsToHrsMins(mins) {
    return new Promise(async (resolve, rejects) => {
      let H: string | number, h = Math.floor(mins / 60);
      let M: string | number, m = mins % 60;
      H = h < 10 ? '0' + h : h;
      M = m < 10 ? '0' + m : m;
      resolve(`${H}.${M}`);
    });
  }

  async findEmpbyRadius(emplist, pickUppoint, radius) {
    return new Promise(async (resolve, rejects) => {
      let resShortLoc, res, resRadiusLoc = [], finalArr = [];
      var empList = emplist.map(value => value.location); // Separate emp location in array for find the shortest route
      resShortLoc = await this.kdtree.findNearestLocation(empList, pickUppoint, empList.length);
      let local = this;
      for (let i = 0; i < resShortLoc.length; i++) {
        let item = resShortLoc[i];
        let url = local.osrmUrl + pickUppoint.lng + ',' + pickUppoint.lat + ";" + item[0].lng + ',' + item[0].lat + '?steps=true';
        res = await local.fetchUrl(url);
        if (res.routes[0].distance < (radius / 2)) {
          resRadiusLoc.push(item);
        }
      }
      for (let i = 0; i < resRadiusLoc.length; i++) {
        for (let j = 0; ; j++) {
          if (resRadiusLoc[i][0].lat == emplist[j].location.lat && resRadiusLoc[i][0].lng == emplist[j].location.lng) {
            finalArr.push(emplist[j].employeeID)
            break;
          }
        }
      }
      resolve(finalArr);
    });
  }
  async findETADist(obj1, obj2) {
    return new Promise(async (resolve, rejects) => {
      try{
      // console.log("findETA Dist");
      let res, retObj = {};
      let url = this.osrmUrl + obj1.lng + ',' + obj1.lat + ';' + obj2.lng + ',' + obj2.lat + '?steps=true';
      res = await this.fetchUrl(url);
      // console.log("url",url)
      retObj["eta"] = res.routes[0].duration / 60;
      retObj["distance"] = res.routes[0].distance / 1000;
      resolve(retObj);
    }catch(error){
        rejects(error)
      }
    });
    
  }

  async findWayPoints(arrLatLon) {
    return new Promise(async (resolve, reject) => {
      let j, url, res, temp_arr = [], temp_arr1 = [], temp_obj = {};
      // console.log("arrLatLon",arrLatLon)
      for (let i = 0; i < arrLatLon.length; i++) {
        temp_arr1.push(arrLatLon[i]);
        j = i + 1;
        if (arrLatLon[j] == undefined) { break; }
        /// -> we cant compare two times with isterchange latlon results of two lat lng bcoz direction must be start frm first latlng////
        url = this.osrmUrl + arrLatLon[i][1] + ',' + arrLatLon[i][0] + ';' + arrLatLon[j][1] + ',' + arrLatLon[j][0] + '?steps=true&geometries=geojson';
        res = await this.fetchUrl(url);
        const lenCoor = res.routes[0].geometry.coordinates.length;
        for (let j = 0; j < lenCoor; j++) {
          temp_arr[0] = res.routes[0].geometry.coordinates[j][1];
          temp_arr[1] = res.routes[0].geometry.coordinates[j][0];
          temp_arr1.push(temp_arr);
          temp_arr = [];
          temp_obj = {};
        }
      }
      // console.log("res-waypoints",temp_arr1)
      resolve(temp_arr1);
    });
  }


  routeCreateNextmvApi(inputObj){
    return new Promise(async (resolve,reject)=>{
      try{
        this.progressBar(10,"Getting Employee and Vehicle data")
        console.log("route will generate",inputObj)
        let data = inputObj[0]['data'],trasitMode=inputObj[0]['trasitMode'],shortedGender,finalObj,resLocationName;
        this.progressBar(25,"Our Intelligence creating the Shortest Route")
        console.log(data)

        let routeGen = await this.RouteCreateNextmv(data).catch((e)=>{throw e});
        if(routeGen["status"] == "failure") reject(routeGen);
        if(inputObj[0].safeDrop == true){
          this.progressBar(50,"Optimizing the Route for SafeDrop")
           shortedGender = await this.shortByGender(routeGen,trasitMode).catch((e)=>{throw e});
        }
        else shortedGender = routeGen;
        this.progressBar(60,"Getting the Location name for "+trasitMode +" points")
        resLocationName = await this.locationName(shortedGender,trasitMode).catch((e)=>{throw e});
        this.progressBar(80,"Calculating the Distance and Duration of each points")
        finalObj = await this.EtaAndDist(resLocationName).catch((e)=>{throw e});
        this.progressBar(100,"Your Route Generated Successfully")

        console.log("finalObj",finalObj)
        resolve(finalObj)
      }catch(error){
        reject(error)
      }
    })
  }

  shortByGender(route,transitMode){
    return new Promise(async(resolve,reject)=>{
      try{
        let tempArr = route['data']['state']['vehicles'];
          if(transitMode == "Pickup"){
            for(let k in tempArr){
              let tempObj = tempArr[k].route
            for(let i=1; i<=tempObj.length-2;i++){
                let split = tempObj[i].id.split('$')
                if(split[1] == "F"){
                  for(let j=i+1; j<=tempObj.length-2;j++){
                    let split = tempObj[j].id.split('$')
                    if(split[1] == "M"){
                      tempObj.splice(i,0,tempObj[j])    //insert element  
                      tempObj.splice(j+1,1)      // delete element
                      break;
                    }
                  }
                }break;
              }
            }}
          else if(transitMode == "Drop"){
            for(let k in tempArr){
              let tempObj = tempArr[k].route
              for(let i=tempObj.length-2;i!=0;i--){
                let split = tempObj[i].id.split('$')
                if(split[1] == "F"){
                  for(let j=i-1;j!=0;j--){
                    let split = tempObj[j].id.split('$')
                    if(split[1] == "M"){
                      tempObj.splice(i+1,0,tempObj[j])
                      tempObj.splice(j,1)
                      break;
                    }
                  }
                }break;
              }
            }
            }

            // route['data']['state']['vehicles'] = tempArr;
            console.log("after gender short", route.data.state.vehicles)
            resolve(route);
          }
          catch(error){
            reject(error);
          }
        });
  }

  locationName(route,trasitMode){
    return new Promise(async (resolve,reject)=>{
      try{
        let url,res;
          for(let i of route['data']['state']['vehicles']){
            for(let j of i.route){
              url = this.osrmUrlloc + j.lon + ',' + j.lat;
              res = await this.fetchUrl(url).catch((e)=>{throw e});
              if (res.code == 'Ok') {
                if(res.waypoints[0].name != "")
                j['locationName'] = res.waypoints[0].name;
                else j['locationName'] = trasitMode +" point" 
              }
            }
          }
       resolve(route);
      }catch(error){
        reject(error);
      }
    })
  }

  EtaAndDist(route){
    return new Promise(async (resolve,reject)=>{
      try{
        let res,eta=0,dist=0,totEta=0,totDist=0;
          let tempObj = route['data']['state']['vehicles'],tempObj1 = route['data']['state']['value_summary']

          for(let i in tempObj){
            for(let j=0;j<tempObj[i].route.length-1;j++){
              let k =j+1,tempArr = tempObj[i].route[j];
              let url = this.osrmUrl + tempArr.lon + ',' + tempArr.lat + ';' + tempObj[i].route[k].lon + ',' + tempObj[i].route[k].lat + '?steps=true';
              res = await this.fetchUrl(url).catch((e)=>{throw e});
              tempObj[i].route[k]['eta'] = await this.convertMinsToHrsMins(Math.round(res.routes[0].duration / 60)).catch((e)=>{throw e});
              tempObj[i].route[k]['distance'] = (res.routes[0].distance / 1000).toFixed(3);
              eta += Number(res.routes[0].duration) ;
              dist += Number(res.routes[0].distance);
            }
            totEta += eta;
            totDist += dist;
            tempObj[i]['travel_time'] = await this.convertMinsToHrsMins(Math.round(eta/ 60)).catch((e)=>{throw e});
            tempObj[i]['travel_distance'] = (dist / 1000).toFixed(3);
            delete  tempObj[i].route[0]['eta']
            delete  tempObj[i].route[0]['distance']
            eta=0,dist=0;
          }
          tempObj1['total_travel_time'] = await this.convertMinsToHrsMins(Math.round(totEta/ 60)).catch((e)=>{throw e});
          tempObj1['total_travel_distance'] = (totDist / 1000).toFixed(3);

          console.log("eta dist", route)

       resolve(route);
      }catch(error){
        reject(error);
      }
    })
  }

  progressBar(percentage, message){
    // return new Promise(async(resolve,reject)=>{
      try{
        // console.log("progress",percentage, message)
          this.share._subject.next({type:'routeGenProg',data: percentage, msg: message});
        // resolve
      }
      catch(error){
        // reject(error)
      }
    // })
  }

}


